// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"44455b78","825":"0ea9057e","940":"44455b78"}[chunkId] + ".chunk.css";
};